import { useEffect, useRef, useState } from "react";

export const useIsScrolling = () => {
  const [isScrolling, setIsScrolling] = useState(false);
  const scrollTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Handle scroll events to disable widget scrolling during page scroll
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolling(true);

      // Clear existing timeout
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }

      // Set a timeout to re-enable widget scrolling after scroll stops
      scrollTimeoutRef.current = setTimeout(() => {
        setIsScrolling(false);
      }, 300); // 300ms delay after scroll stops
    };

    // Add scroll listener to the scrolling-container element
    const scrollingContainer = document.getElementById("scrolling-container");
    if (scrollingContainer) {
      scrollingContainer.addEventListener("scroll", handleScroll, {
        passive: true,
      });
    }

    // Cleanup
    return () => {
      if (scrollingContainer) {
        scrollingContainer.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);

  return isScrolling;
};
